<template>
  <div class="page-content">
    <div class="row">
      <div class="col-12">
        <gourmet-charge />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import GourmetCharge from './Gourmet/GourmetCharge.vue';

import util from '@/Utils/util';

export default {
  name: 'Gourmet',

  components: {
    GourmetCharge,
  },

  setup: () => {
    onMounted(async () => {
      const route = useRoute();
      const { hash } = route;

      await nextTick();
      util.moveScrollComponent(hash);
    });
  },
};
</script>
